module.exports = __webpack_public_path__ + "static/media/garosugil.53d97f73.jpg";